import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledContainer = styled(Box)``;
export const StyledHeaderContainer = styled(Flex)``;
export const StyledHed = styled(Box)``;
export const StyledDek = styled(Box)``;
export const StyledPhotoContainer = styled(Box)``;
export const StyledDekMobile = styled(Box)<{ isDescriptionShown?: boolean | false }>`
  margin-bottom: 8px;
  height: ${({ isDescriptionShown }) => (isDescriptionShown ? 'fit-content' : '85px')};
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: normal;
  max-width: 342px;
  display: ${({ isDescriptionShown }) => (isDescriptionShown ? 'block' : '-webkit-box')};
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const StyledShowMoreButton = styled(Box)`
  width: fit-content;
  transition: animationTransition('color');
`;

const containerStyles: StyleSystemProps = {
  height: '100%',
  paddingBottom: '24px',
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexDirection: 'column',
};

const headerContainerStyles: StyleSystemProps = {
  alignItems: 'center',
  flexDirection: 'column',
};

const hedStyles: StyleSystemProps = {
  typographyVariant: ['HedMobile32', null, 'Hed56'],
  fontWeight: ['light', null, 'light'],
  transition: animationTransition('color'),
  maxWidth: '574px',
  textAlign: 'center',
  marginX: 6,
};

const dekStyles: StyleSystemProps = {
  lineHeight: ['22.5px', null, null, '24px'],
  typographyVariant: ['body1', null, 'body3'],
  width: ['300px', null, '738px'],
  maxWidth: ['296px', null, '574px'],
  textAlign: 'center',
  transition: animationTransition('color'),
  paddingTop: '16px',
  paddingBottom: ['10px', null, '50px'],
};

const logoStyles: StyleSystemProps = {
  width: '100%',
  maxWidth: ['200px', null, '300px'],
};

export const styles = {
  container: containerStyles,
  headerContainer: headerContainerStyles,
  hed: hedStyles,
  dek: dekStyles,
  logo: logoStyles,
};
